import Detenteur from "../models/Detenteur";
import localforage from "localforage";
import Installation from "../models/Installation";

class Initialisation {
    constructor(apiKey) {
        let params = {
            baseURL: urlAPI,
            headers: {
                'Authorization': 'Bearer ' + apiKey
            }
        };

        this.params = {'url': urlAPI, 'key' : apiKey};
        this.api = axios.create(params);
    }

    initMAJ() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/request/information/fi360')
                .then(function(result){
                    resolve(result.data);
                }).catch(err => resolve({statusBackOffice: '0', statusApp: '0', cacheHeure: 24}))
        })
    }

    initOfflineActions() {
        return new Promise((resolve, reject) => {
            localforage
                .setItem('offlineActions', JSON.stringify([]))
                .then(() => resolve(true))
                .catch(err => reject(err))
        })
    }

    initTypesOutil() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/type/outil')
                .then(function (result) {
                    let types = result.data.types;

                    localforage
                        .setItem('listTypesOutil', JSON.stringify(types))
                        .then(() => resolve(true))
                        .catch(err => reject(err))

                }).catch(err => reject(err))
        })
    }

    initTypesOperation() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/type/operation')
                .then(function (result) {

                    let types = result.data.types;

                    localforage
                        .setItem('listTypesOperation', JSON.stringify(types))
                        .then(() => resolve(true))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        })
    }

    initAssemblages() {
        return new Promise((resolve, reject) => {
            localforage
                .setItem('listAssemblages', JSON.stringify([]))
                .then(() => resolve(true))
                .catch(err => reject(err))
        })
    }

    initFibsdds() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/fibsdds')
                .then(function (result) {
                    let fibsdds = result.data.fibsdds;

                    localforage
                        .getItem('listPhotos')
                        .then(data => {
                            let photos = JSON.parse(data) || [];

                            _.each(fibsdds, fi => {
                                _.each(fi.photos, p => {
                                    let payload = {};

                                    payload.idFi = fi.id;
                                    payload.id = p.id;
                                    payload.isUrl = !!p.photo_url;
                                    payload.data64 = p.photo_url ? (urlAPI + p.photo_url) : p.photo64;

                                    photos.push(payload)
                                })
                            });
                            localforage.setItem('listPhotos', JSON.stringify(photos))

                        })
                        .catch(err => reject(err));

                    localforage
                        .getItem('listPieces')
                        .then(data => {

                            let pieces = JSON.parse(data);
                            _.each(fibsdds, fi => {
                                _.each(fi.pieces, piece => {

                                    let payload = {};
                                    payload.fiche = fi.id;
                                    payload.prix = piece.price;
                                    payload.etat = piece.changed;
                                    payload.qte = piece.quantity;
                                    payload.id = piece.id;
                                    payload.designation = piece.designation;

                                    pieces.push(payload)
                                })
                            });
                            localforage.setItem('listPieces', JSON.stringify(pieces))

                        })
                        .catch(err => reject(err));

                    localforage
                        .getItem('listFuites')
                        .then(res => {

                            let listFuites = JSON.parse(res);

                            _.each(fibsdds, fi => {
                                _.each(fi.fuites, fuite => {
                                    fuite.dossier = fi.id;
                                    listFuites.push(fuite)
                                })
                            });

                            localforage.setItem('listFuites', JSON.stringify(listFuites))

                        }).catch(err => reject(err));


                    let cleanList = fibsdds.map(fi => {

                        let payload = {};


                        payload.id = fi.id;
                        payload.numero = fi.numero;
                        payload.ordre_travail = fi.ordre_travail;
                        payload.detenteur = fi.detenteur.id;
                        payload.detenteurString = fi.detenteur.raison_sociale;
                        payload.installation = fi.installation.id;
                        payload.charge_init = fi.charge_initiale;
                        payload.affectation_user = fi.affectation_user ? fi.affectation_user.id : null;

                        if(fi.fluide_init){
                            payload.fluide_init = fi.fluide_init.id
                        }

                        payload.cloture = false;
                        payload.cloturedAt = null;

                        if (fi.hasOwnProperty('detecteur') && !_.isEmpty(fi.detecteur)) {
                            fi.detecteur = fi.detecteur.id
                        } else {
                            fi.detecteur = null
                        }

                        payload.natures = {};
                        payload.natures.assemblage = fi.intervention_assemblage;
                        payload.natures.miseEnService = fi.intervention_mise_en_service;
                        payload.natures.modification = fi.intervention_modification;
                        payload.natures.maintenance = fi.intervention_maintenance;
                        payload.natures.controlePeriodique = fi.intervention_controle_p;
                        payload.natures.controleNonPeriodique = fi.intervention_controle_np;
                        payload.natures.demantelement = fi.intervention_demantelement;
                        payload.natures.retrofit = fi.intervention_retrofit;
                        payload.natures.autres = fi.intervention_autre;
                        payload.natures.observations = fi.nature_intervention;
                        payload.natures.description = fi.description;
                        payload.natures.contractuel = fi.contractuel;

                        if (fi.nouveau_fluide) {
                            payload.natures.newFluide = fi.nouveau_fluide.id
                        } else {
                            payload.natures.newFluide = null
                        }
                        if (fi.hasOwnProperty('fluide_init') && !_.isEmpty(fi.fluide_init)) {
                            fi.fluide_init = fi.fluide_init.id
                        } else {
                            fi.fluide_init = null
                        }

                        payload.ctrlEtanch = {};
                        payload.ctrlEtanch.no_fuites = fi.no_fuites;

                        payload.informations = {};
                        payload.informations.temps_deplacement = fi.temps_deplacement;
                        payload.informations.temps_intervention = fi.temps_intervention;
                        payload.informations.pieces = fi.desc_pieces;
                        payload.informations.heure_arrivee = fi.heure_arrivee;
                        payload.informations.heure_depart = fi.heure_depart;
                        payload.informations.kilometrage = fi.kilometrage;
                        payload.informations.observations = fi.observations;
                        payload.informations.photo64 = fi.photo64;

                        payload.informations.techs = fi.techs;
                        payload.informations.namesTechniciens = fi.names_techniciens;

                        payload.informations.preventif = fi.preventif;
                        payload.informations.correctif = fi.correctif;
                        payload.informations.fromDevis = fi.from_devis;
                        payload.informations.garantie = fi.garantie;
                        payload.informations.finish = fi.finish;
                        payload.informations.needDevis = fi.need_devis;
                        payload.informations.travauxEffectues = fi.travaux_effectues;

                        payload.infosDet = {};
                        payload.infosDet.nom_signataire = fi.nom_signataire;
                        payload.infosDet.fonction_signataire = fi.fonction_signataire;
                        payload.infosDet.signature_signataire64 = fi.signature_signataire64;

                        payload.photos = [];

                        return payload
                    });

                    localforage
                        .setItem('listFibsdd', JSON.stringify(cleanList))
                        .then(() => resolve(true))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    initBouteilles() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/bouteilles')
                .then(function (result) {

                    let bouteilles = _.map(result.data.bouteilles, bout => {
                        bout.created_at = moment(bout.created_at).format('YYYY-MM-DD HH:mm:ss');
                        return bout
                    });

                    localforage
                        .setItem('listBouteilles', JSON.stringify(bouteilles))
                        .then(() => resolve(true))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        })
    }


    initDetenteursAndInstall() {
        return new Promise(async (resolve, reject) => {

            let detenteursInCache = await Detenteur.getList();

            //Vérification qu'il est possible d'utiliser le service Worker pour le faire en arrière plan
            if ('serviceWorker' in navigator && detenteursInCache !== null) {
                //add localStorage key async detenteurs
                localStorage.setItem('asyncDetenteurs', true);
                let apiInfo = this.params;
                navigator.serviceWorker.ready.then(function (registration) {

                    registration.active.postMessage({'action': 'initialisation', 'type': 'detenteurs', 'api': apiInfo});
                })
                return resolve(true);
            }


            this.api
                .get('/detenteurs')
                .then(function (result) {

                    Detenteur.stockDetenteursOnLocal(result.data.detenteurs).then(function () {
                        resolve(true);
                    }).catch(err => reject(err));


                })
                .catch(err => reject(err))

        })
    }

    initProfil() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/me')
                .then(function (result) {

                    let profil = result.data;

                    if(profil.immatriculation != null) {
                        const p = /^([0-9]+|[a-z]+)(?:\s|-)?([a-z]+|[0-9]+)(?:\s|-)?([a-z]+|[0-9]+)$/i;
                        if (profil.immatriculation.match(/^[a-hj-np-tv-z]{2}(?:\s|-)?[\d]{3}(?:\s|-)?[a-hj-np-tv-z]{2}$/i)) {
                            profil.immatriculation = profil.immatriculation.replace(p, '$1-$2-$3').toUpperCase();
                        }

                        if (profil.immatriculation.match(/^[0-9]{1,4}(?:\s|-)?[a-hj-np-tv-z]{2,3}(?:\s|-)?(?:97[1-6]|0[1-9]|[1-8][0-9]|9[1-5]|2[ab])$/i)) {
                            profil.immatriculation =  profil.immatriculation.replace(p, '$1 $2 $3').toUpperCase();
                        }
                    }


                    localStorage.setItem('canEditDetenteurs', profil.can_edit_detenteurs);
                    localStorage.setItem('canEditInstallations', profil.can_edit_installations);
                    localStorage.setItem('typeUser', profil.type);
                    localStorage.setItem('activateTrackDechets', profil.operator.activate_track_dechets);
                    localStorage.setItem('hasTransporterTd', profil.operator.has_transporter_td);

                    localforage
                        .setItem('profil', JSON.stringify(profil))
                        .then(() => resolve(true))
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))
        })
    }

    initOptions() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/options/all')
                .then(function (result){
                    let results = result.data;

                    let options = [];

                    results.forEach(function(o) {
                        options.push(o.options.name);
                    });

                    localforage
                        .setItem('listOptions', JSON.stringify(options))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                })
        })
            .catch(err => reject(err))
    }

    requestTD() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/request/actualise/trackdechets')
                .then(function (result) {

                    if(result.status == 200) {
                        resolve(true);
                    }
                })
                .catch(function(err) {
                    //Patch si la page d'api n'existe pas on fait rien, pas grave
                    if(err.response.status == 404) {
                        resolve(true);
                    }else{
                        reject(err);
                    }
                })
        })
    }

    getInformationBouteille() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/information/bouteille/distributeur')
                .then(function (result) {
                    let informations = result.data;
                    localforage
                        .setItem('informationBouteille', JSON.stringify(informations))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                })
                .catch(function () {
                    // Non critique, on continue si ça échoue
                    resolve(true);
                })
        })
    }

    initEvents() {
        return new Promise((resolve, reject) => {

            resolve(true);
            let events = [];
            let countEventsNoRead = 0;

            this.api
                .get('/planning/events/all')
                .then(function (result){
                    let results = result.data;

                    results.forEach(function(event) {
                        if(event.isReading === false){
                            countEventsNoRead++;
                        }
                        events.push(event);
                    });
                })

            this.api
                .get('/planning/events/update/reading')
                .then(function (result){

                    localforage
                        .setItem('listEvents', JSON.stringify(events))
                        .then(() => localforage.setItem('parameters', JSON.stringify({nbEvent: countEventsNoRead})))
                        .then(() => resolve(true))
                        .catch(err => reject(err))

                })
        })
            .catch(err => reject(err))
    }

    initOthersApi() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/listings/entretien')
                .then(function (result) {
                    let listTypeEntretien = result.data;

                    localforage
                        .setItem('listTypesEntretien', JSON.stringify(listTypeEntretien))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                }).catch(err => reject(err))
        })
    }

    initOutils() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/outils')
                .then(function (result) {
                    let outils = result.data.outils.filter(o => o.deleted !== true);

                    localforage
                        .setItem('listOutils', JSON.stringify(outils))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    initFournisseurs() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/fournisseurs')
                .then(function (result) {

                    let fournisseurs = result.data.fournisseurs;

                    localforage
                        .setItem('listFournisseurs', JSON.stringify(fournisseurs))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    initDistributeurs() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/distributeurs')
                .then(function (result) {

                    let distributeurs = result.data.distributeurs;

                    localforage
                        .setItem('listDistributeurs', JSON.stringify(distributeurs))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    initTransporteurs(){
        return new Promise((resolve, reject) => {
            this.api
                .get('/transporteurs')
                .then(function (result) {
                    let transporteurs = result.data.transporteurs;

                    localforage
                        .setItem('listTransporteurs', JSON.stringify(transporteurs))
                        .then(() => resolve(true))
                        .catch(err => reject(err));
                }).catch(err => reject(err))

        })
    }

    initFluides() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/fluides')
                .then(function (result) {

                    let fluides = result.data.fluides;

                    localforage
                        .setItem('listFluides', JSON.stringify(fluides))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    initNomsBouteilles() {
        return new Promise((resolve, reject) => {
            this.api
                .get('/nom/bouteilles')
                .then(function (result) {

                    let noms = result.data.noms;

                    localforage
                        .setItem('listNomBout', JSON.stringify(noms))
                        .then(() => resolve(true))
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))
        })
    }

    initOperations() {
        return new Promise((resolve, reject) => {

            this.api
                .get('/operations')
                .then(function (result) {

                    let operations = result.data.operations;
                    //console.log(operations);
                    localforage
                        .getItem('listUsers')
                        .then(function() {
                            let ops = operations.map(op => {

                                //console.log(op.user.id);
                                //console.log(op);

                                return {
                                    id: op.id,
                                    id_fibsdd: op.fibsdd ? op.fibsdd.id : null,
                                    id_bouteille: op.bouteille.id,
                                    id_fluide: op.fluide.id,
                                    id_type: op.type.id,
                                    id_detenteur: op.fibsdd ? op.fibsdd.detenteur.id : null,
                                    type: op.type.name,
                                    quantite: op.quantite,
                                    date: op.created_at,
                                    user: op.user.id
                                }

                            });

                            localforage
                                .setItem('listOperations', JSON.stringify(ops))
                                .then(res => resolve(res))
                                .catch(err => reject(err))


                        })
                        .catch(err => reject(err))

                })
                .catch(err => reject(err))

        })

    }

    initScans() {
        return new Promise((resolve, reject) => {

            this.api
                .get('/scans')
                .then(function (result) {
                    let scans = _.map(result.data.scans, scan => {
                        scan.bouteille = scan.bouteille.id;
                        return scan
                    });
                    localforage
                        .setItem('listScans', JSON.stringify(scans))
                        .then(res => resolve(res))
                        .catch(err => reject(err))
                })
                .catch(err => reject(err))

        })
    }

    initFuites() {

        return new Promise((resolve, reject) => {

            localforage
                .setItem('listFuites', JSON.stringify([]))
                .then(res => resolve(res))
                .catch(err => reject(err))

        })

    }

    initPieces() {

        return new Promise((resolve, reject) => {

            localforage
                .setItem('listPieces', JSON.stringify([]))
                .then(res => resolve(res))
                .catch(err => reject(err))

        })

    }

    initPhotosFiche() {

        return new Promise((resolve, reject) => {

            localforage
                .setItem('listPhotos', JSON.stringify([]))
                .then(res => resolve(res))
                .catch(err => reject(err))

        })

    }

    initUsers() {
        return new Promise((resolve, reject) => {
            this
                .api
                .get('/operateur/users')
                .then(res => {
                    //TODO:: Vérifier en octobre si on doit toujours vérifier si c'est un tableau ou un objet ???
                    if (res.data.users) {

                        let source = Array.isArray(res.data.users)
                            ? res.data.users
                            : Object.values(res.data.users);

                        let usrs = source.map(usr => ({
                            id: usr.id,
                            nom: usr.first_name.trim().charAt(0).toUpperCase() + '. ' + usr.last_name.toUpperCase()
                        }));

                        localforage
                            .setItem('listUsers', JSON.stringify(usrs))
                            .then(() => resolve(true))
                            .catch(err => reject(err));
                    } else {

                        reject("erreur lors de la récuperation des users de l'operateur")

                    }
                })
                .catch(err => reject(err))
        })
    }

    initOtags() {

        return new Promise(async (resolve, reject) => {

            let otagsInCache = await localforage.getItem('OTAGS')

            if('serviceWorker' in navigator && otagsInCache !== null){
                let apiInfo = this.params;
                navigator.serviceWorker.ready.then(function(registration) {

                    registration.active.postMessage({'action': 'initialisation', 'type': 'otags', 'api': apiInfo});
                })
                return resolve(true);
            }

            this
                .api
                .get('/otags3')
                .then(res => {

                    if (res.data.otags) {
                        let otags = res.data.otags;

                        localforage
                            .setItem('OTAGS', JSON.stringify(otags))
                            .then(() => resolve(true))
                            .catch(err => reject(err))

                    } else {

                        reject('erreur lors de la récuperation des otags')

                    }

                })
                .catch(err => reject(err))

        })

    }

    getLastsDetenteurs() {
        return new Promise(async (resolve, reject) => {
            let detenteursInCache = await Detenteur.getList();
            if(!_.isEmpty(detenteursInCache)){
                if (detenteursInCache != null) {
                    let lastId = detenteursInCache[detenteursInCache.length - 1].id;

                    this.api
                        .get('/detenteur/last/' + lastId)
                        .then(function (result) {
                            if (result.status === 200) {
                                Detenteur.addNewDetenteurs(result.data).then(function () {
                                    resolve(true);
                                }).catch(err => reject(err));
                            } else {
                                resolve(true);
                            }
                        })
                        .catch(err => reject(err))
                }
            }

            resolve(true);
        })
    }
}

export default Initialisation



// WEBPACK FOOTER //
// ./src/js/core/Initialisation.js